import React, { useState, useEffect } from "react";
import OtpVerify from "./OtpVerify";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import { localserver, ROUTE_BASE_URL } from "../../api/common";
import { Link, useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "../../assets/images/logo.png";

export default function Login() {
  const history = useHistory();
  const [enableOtp, setEnableOtp] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [email, setEmail] = useState(
    localStorage.getItem("rememberEmail") || ""
  );
  const [password, setPassword] = useState(
    localStorage.getItem("rememberPassword") || ""
  );
  const [rememberMe, setRememberMe] = useState(
    !!localStorage.getItem("rememberEmail")
  );
  const [showPassword, setShowPassword] = useState(false);
  const [activeTab, setActiveTab] = useState("otp"); // "otp" or "password"
  const [sendOtpStatus, setSendOtpStatus] = useState(false);

  useEffect(() => {
    if (rememberMe && localStorage.getItem("rememberEmail")) {
      setEmail(localStorage.getItem("rememberEmail"));
      setPassword(localStorage.getItem("rememberPassword") || "");
    }
  }, []);

  const handleTabChange = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const [otp, setOtp] = useState("");
  const sendOtp = async () => {
    if (!email) {
      showToast("Email cannot be empty", "error");
      return;
    }
    if (activeTab === "password" && !password) {
      showToast("Password cannot be empty", "error");
      return;
    }

    setSendOtpStatus(true);
    try {
      const response = await axios.post(
        `${localserver}/${
          activeTab === "otp" ? "send_otp_mail" : "user_login"
        }`,
        {
          ...(activeTab === "otp" && { email_id: email }),
          ...(activeTab === "password" && {
            email_id: email,
            password: password,
          }),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        console.log(response.data, "response.data");
        if (activeTab === "otp") {
          // setOtp(response.data.otp);
          showToast(response.data.message, "success");
          if (rememberMe) {
            localStorage.setItem("rememberEmail", email);
          } else {
            localStorage.removeItem("rememberEmail");
          }
          setEnableOtp(true);
        }else {
          showToast(response.data.message, "success");
  
          // Store user details
          Cookies.set("userId", response.data.user.id, { expires: 1 });
          localStorage.setItem("access_token", response.data.token);
          localStorage.setItem("loginUserId", response.data.user.id);
          localStorage.setItem(
            "loginUserName",
            `${response.data.user.first_name} ${response.data.user.last_name}`
          );
  
          // Store credentials if "Remember me" is checked
          if (rememberMe) {
            localStorage.setItem("rememberEmail", email);
            localStorage.setItem("rememberPassword", password);
          } else {
            localStorage.removeItem("rememberEmail");
            localStorage.removeItem("rememberPassword");
          }
  
          history.replace(`${ROUTE_BASE_URL}`);
        }
      
      }else{
        showToast(response.data.message, "error"); 
      }
    } catch (error) {
      console.error("Error during submission:", error);
      showToast("Please try again", "error");
    } finally {
      setSendOtpStatus(false);
    }
  };

  // JSX Methods for UI Components
  const renderLogo = () => {
    return (
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img
          src={logo || "/placeholder.svg"}
          width="80"
          height="80"
          alt="AMASI Logo"
          
        />
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h1
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            color: "#1a1a1a",
            marginBottom: "8px",
            margin: "0 0 8px 0",
          }}
        >
          AMASI Admin Dashboard
        </h1>
        <p
          style={{
            color: "#666666",
            fontSize: "14px",
            lineHeight: "1.5",
            margin: "0",
          }}
        >
          Welcome back! Please login to access your admin panel
        </p>
      </div>
    );
  };

  const renderTabButton = (tabKey, label) => {
    const isActive = activeTab === tabKey;

    return (
      <button
        onClick={() => handleTabChange(tabKey)}
        style={{
          flex: 1,
          padding: "12px 16px",
          border: "none",
          backgroundColor: isActive ? "#184778" : "#f8f9fa",
          color: isActive ? "#ffffff" : "#184778",
          fontSize: "14px",
          fontWeight: "500",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          borderRadius: tabKey === "otp" ? "8px 0 0 8px" : "0 8px 8px 0",
        }}
        onMouseOver={(e) => {
          if (!isActive) {
            e.target.style.backgroundColor = "#e9ecef";
          }
        }}
        onMouseOut={(e) => {
          if (!isActive) {
            e.target.style.backgroundColor = "#f8f9fa";
          }
        }}
      >
        {label}
      </button>
    );
  };

  const renderTabs = () => {
    return (
      <div style={{ marginBottom: "24px" }}>
        <div
          style={{
            display: "flex",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            overflow: "hidden",
            marginBottom: "16px",
          }}
        >
          {renderTabButton("otp", "Login with OTP")}
          {renderTabButton("password", "Login with Password")}
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "#666666",
            textAlign: "center",
            padding: "8px 0",
          }}
        >
          {activeTab === "otp"
            ? "Enter your email and click send OTP to receive an OTP."
            : "Enter your email and password to login."}
        </div>
      </div>
    );
  };

  const renderEmailInput = () => {
    return (
      <div style={{ marginBottom: "20px" }}>
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: "#374151",
            marginBottom: "6px",
          }}
        >
          Email <span style={{ color: "#ef4444" }}>*</span>
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your Email"
          style={{
            width: "100%",
            padding: "12px 16px",
            border: "2px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
            outline: "none",
            transition: "border-color 0.2s ease-in-out",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#4285f4";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#d1d5db";
          }}
        />
      </div>
    );
  };

  const renderPasswordInput = () => {
    if (activeTab !== "password") return null;

    return (
      <div style={{ marginBottom: "20px" }}>
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: "#374151",
            marginBottom: "6px",
          }}
        >
          Password <span style={{ color: "#ef4444" }}>*</span>
        </label>
        <div style={{ position: "relative" }}>
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your Password"
            style={{
              width: "100%",
              padding: "12px 16px",
              paddingRight: "48px",
              border: "2px solid #d1d5db",
              borderRadius: "8px",
              fontSize: "14px",
              outline: "none",
              transition: "border-color 0.2s ease-in-out",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#4285f4";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#d1d5db";
            }}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#666666",
              fontSize: "16px",
            }}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </button>
        </div>
      </div>
    );
  };

  const renderRememberMeSection = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            fontSize: "14px",
            color: "#374151",
          }}
        >
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={handleRememberMeChange}
            style={{
              marginRight: "8px",
              width: "16px",
              height: "16px",
              cursor: "pointer",
            }}
          />
          Remember me
        </label>
        {/* <Link
          to={`${ROUTE_BASE_URL}/forgot-password`}
          style={{
            fontSize: "14px",
            color: "#4285f4",
            textDecoration: "none",
          }}
          onMouseOver={(e) => {
            e.target.style.textDecoration = "underline";
          }}
          onMouseOut={(e) => {
            e.target.style.textDecoration = "none";
          }}
        >
          Forgot Email?
        </Link> */}
      </div>
    );
  };

  const renderSubmitButton = () => {
    const isDisabled =
      sendOtpStatus || !email || (activeTab === "password" && !password);

    return (
      <button
        onClick={sendOtp}
        disabled={isDisabled}
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "8px",
          fontWeight: "500",
          fontSize: "16px",
          border: "none",
          cursor: isDisabled ? "not-allowed" : "pointer",
          backgroundColor: isDisabled ? "#e5e7eb" : "#184778",
          color: isDisabled ? "#9ca3af" : "#ffffff",
          transition: "all 0.2s ease-in-out",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
        }}
        onMouseOver={(e) => {
          if (!isDisabled) {
            e.target.style.backgroundColor = "#3e6d9eff";
          }
        }}
        onMouseOut={(e) => {
          if (!isDisabled) {
            e.target.style.backgroundColor = "#184778";
          }
        }}
      >
        {sendOtpStatus ? (
          <>
            <span
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #ffffff",
                borderTop: "2px solid transparent",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginRight: "8px",
              }}
            ></span>
            Processing...
          </>
        ) : activeTab === "otp" ? (
          "Send OTP"
        ) : (
          "Login"
        )}
      </button>
    );
  };

  const renderHelpSection = () => {
    return (
      <div style={{ textAlign: "center" }}>
        <p
          style={{
            fontSize: "14px",
            color: "#666666",
            margin: "0",
          }}
        >
          <Link
            to={`${ROUTE_BASE_URL}`}
            style={{
              color: "#4285f4",
              textDecoration: "none",
            }}
            onMouseOver={(e) => {
              e.target.style.textDecoration = "underline";
            }}
            onMouseOut={(e) => {
              e.target.style.textDecoration = "none";
            }}
          >
            Need help?
          </Link>{" "}
          Contact support
        </p>
      </div>
    );
  };

  const renderLoginForm = () => {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f9fafb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            width: "100%",
            maxWidth: "550px",
          }}
        >
          {renderLogo()}
          {renderHeader()}
          {renderTabs()}
          {renderEmailInput()}
          {renderPasswordInput()}
          {renderRememberMeSection()}
          {renderSubmitButton()}
          {/* {renderHelpSection()} */}
        </div>

        {/* Add CSS animation for spinner */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };

  // Main Render Method
  return (
    <>
      <ToastMessage />
      {!enableOtp ? renderLoginForm() : <OtpVerify adminEmail={email} mailOtp={otp} />}
    </>
  );
}
